import React from 'react'
import { Select, Input } from '@baseV2'
import { FieldsRow, FieldItem } from './styles'
import { numberChangeHandler, uppercaseTrimmedChangeHandler, weightLabel } from './inputAdapters'
import BrandsField from './BrandsField'

const targetPriceLabel = (inputType) =>
	inputType.value === 'LENGTH' ? 'Target Price per Meter' : inputType.value === 'PIECES' ? 'Target Price per Piece' : 'Target Price per MT'

const SimpleProductFields = ({ product, brands, requiredWeight, inputType, preferredUnits, targetPrice, grade, activeCommodity, onChange, user }) => (
	<>
		<FieldsRow>
			<FieldItem>
				<Select
					id='enquiry-product-select'
					disabled={product?.disabled}
					label={product?.label}
					displayKey={product?.displayKey}
					primaryKey={product?.primaryKey}
					placeholder={product?.placeholder}
					data={product?.data}
					value={product?.value}
					onChange={onChange('product')}
					createNewOption={true}
				/>
			</FieldItem>
			<BrandsField brands={brands} onChange={onChange('brands')} user={user} />
		</FieldsRow>
		<FieldsRow>
			{activeCommodity?.commodity_name === 'scrap' ? (
				<FieldItem>
					<Input
						type='number'
						disabled={requiredWeight?.disabled}
						label={requiredWeight?.label}
						value={requiredWeight?.value}
						onChange={numberChangeHandler(onChange('requiredWeight'))}
					/>
				</FieldItem>
			) : (
				<>
					<FieldItem>
						<Select
							id='selected-unit'
							label={inputType?.label}
							placeholder={inputType?.placeholder}
							data={preferredUnits}
							displayKey='label'
							primaryKey='key'
							value={preferredUnits.find((item) => item.key === inputType.value) ?? {}}
							onChange={onChange('inputType')}
						/>
					</FieldItem>
					<FieldItem>
						<Input
							type='number'
							disabled={requiredWeight?.disabled || !inputType?.value}
							label={weightLabel(inputType)}
							value={requiredWeight?.value}
							onChange={numberChangeHandler(onChange('requiredWeight'))}
						/>
					</FieldItem>
				</>
			)}
		</FieldsRow>
		<FieldsRow>
			<FieldItem>
				<Input
					type='number'
					disabled={targetPrice?.disabled}
					label={targetPriceLabel(inputType)}
					value={targetPrice?.value}
					onChange={numberChangeHandler(onChange('targetPrice'))}
				/>
			</FieldItem>
			<FieldItem>
				<Input
					type='text'
					label={grade?.label}
					placeholder={grade?.placeholder}
					value={grade?.value}
					disabled={grade?.disabled}
					onChange={uppercaseTrimmedChangeHandler(onChange('grade'))}
				/>
			</FieldItem>
		</FieldsRow>
	</>
)

export default SimpleProductFields
